import { useApiStore } from '@/stores/apiStore';
import { LanguageCodesApi } from '@/../generated-client/apis/LanguageCodesApi';

let languageCodesApi: LanguageCodesApi | null = null;
let lastConfig: unknown = null;

function getLanguageCodesApi(): LanguageCodesApi {
  const { apiConfig } = useApiStore.getState();

  // if config changed (token refresh), rebuild
  if (languageCodesApi === null || lastConfig !== apiConfig) {
    languageCodesApi = new LanguageCodesApi(apiConfig);
    lastConfig = apiConfig;
  }

  return languageCodesApi;
}

export const getAllLanguageCodes = async () => {
  const api = getLanguageCodesApi();

  return await api.apiLanguageCodesGetAllGet();
};
